import { Button } from "antd";
import HeaderGestaoJobs from "./Header";
import FiltersNotificacoes from "./Filters";
import useGetConfiguracaoNotificacoes from "./hooks/useGetConfiguracaoNotificacoes";
import useGetDestinatarios from "./hooks/useGetDestinatarios";
import useModal from "./hooks/useModal";
import { useEffect, useState } from "react";
import { columns } from "./columns";
import DatatableAntd from "components/datatable-antd";
import styled from "styled-components";
import CreateEditModal from "./components/CreateEditModal";

export default function ConfiguracaoNotificacoes() {

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const { setIsOpen } = useModal();

  const { data, refetch } = useGetConfiguracaoNotificacoes();
  const {
    data: destinatarios,
    isLoading: loadingDestinatarios,
    refetch: refetchDestinatarios,
  } = useGetDestinatarios();

  const handleRefetchCreateEditModal = () => {
    refetch();
    refetchDestinatarios();
  }

  useEffect(() => {
    if (data) {
      setTotal(data?.paginate?.totalCount);
    }
  }, [data]);

  return (
    <Container>
      <HeaderGestaoJobs />
      <FiltersNotificacoes data={data} />

      <Counter>
        <b>Destinatários Cadastrados</b>
        <Button
          size="large"
          type="primary"
          onClick={() => setIsOpen(true)}
          style={{
            borderRadius: 8,
            backgroundColor: "#12619C",
          }}
        >Novo Destinatário</Button>
      </Counter>

      <RoundedTable
        style={{ margin: 16 }}
        columns={columns}
        loading={loadingDestinatarios}
        dataSource={destinatarios ?? []}
        pagination={{
          total,
          pageSize,
          current: page,
          showSizeChanger: true,
          onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
          },
        }}
      />
      <CreateEditModal refetch={handleRefetchCreateEditModal} />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;

const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }
`;

const Counter = styled.div`
  margin: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  border: 1px solid #e2e8f0;
  padding: 18px;
  border-radius: 8px;

  p {
    color: #fff;
    font-weight: bold;
    background-color: #12619c;
    padding: 4px 12px;
    border-radius: 15px;
  }
`;
